// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"01a9bd5e","147":"213bdbfd","849":"1c7b68b0","861":"51677d9c","886":"b8e5eb94","931":"3326e616"}[chunkId] + ".chunk.js";
};